<script setup>
    import { onMounted, computed, ref } from 'vue';
    import axios from 'axios';

    const customers = ref([]);    
    const emit = defineEmits(['changed']);
    const selectedCustomerIds = ref([]);
    const selectedCustomerAccountIds = ref([]);

    async function loadCustomers() {
        const response = await axios.get("/api/Customer/List");
        if (response.status !== 200) return;
        customers.value = response.data.map(x => (
            {
                id: x.id,
                name: x.name,
                expanded: false,
                accounts: x.accounts.map(a => ({ id: a.id, name: a.name, customerId: x.id  }))
            }));
    }

    function getSelectedSummary() {
        return {
            customerIds: selectedCustomerIds.value,
            customerAccountIds: selectedCustomerAccountIds.value
        };
    }

    function setCustomerState(state, customer) {
        var idx = selectedCustomerIds.value.indexOf(customer.id);
        if (!state && idx >= 0) selectedCustomerIds.value.splice(idx, 1);
        if (state && idx < 0) selectedCustomerIds.value.push(customer.id);
    }

    function setCustomerAccountState(state, account) {
        var idx = selectedCustomerAccountIds.value.indexOf(account.id);
        if (!state && idx >= 0) selectedCustomerAccountIds.value.splice(idx, 1);
        if (state && idx < 0) selectedCustomerAccountIds.value.push(account.id);
    }

    async function customerSelectionChanged(event, customer) {        
        var selected = event.target.checked;        
        setCustomerState(selected, customer);
        
        customer.accounts.forEach(x => setCustomerAccountState(selected,x));
        emit('changed', getSelectedSummary());
    }

    async function accountSelectionChanged(event, account) {        
        var selected = event.target.checked;
        setCustomerAccountState(selected, account);

        var parent = customers.value.find(x => x.accounts != null && x.accounts.indexOf(account) >= 0);
        
        if (parent == null) return;
        var selectedCount = parent.accounts.filter(x => x.selected == true).length;
        if (selectedCount !== parent.accounts.length) parent.selected = false; //uncheck the customer checkbox if all the child accounts are not checked
        if (selectedCount == parent.accounts.length) parent.selected = true; //check the customer checkbox if all the child accounts are checked
        emit('changed', getSelectedSummary());
    }

    const isAccountSelected = (account) => selectedCustomerAccountIds.value.indexOf(account.id) >= 0;
    const isCustomerSelected = (customer) => selectedCustomerIds.value.indexOf(customer.id) >= 0;

    function applyFilters( customerIds, customerAccountIds ) {
        selectedCustomerIds.value = customerIds || [];
        selectedCustomerAccountIds.value = customerAccountIds || [];

        customers.value.forEach(customer => {
            customer.accounts.forEach(account => {
                setCustomerAccountState(isAccountSelected(account), account);
            })
            setCustomerState(isCustomerSelected(customer), customer);
            var selectedAccountLength = customer.accounts.filter(isAccountSelected).length;
            if (selectedAccountLength > 0) customer.expanded = true;
        })
    }

    async function resetFilters() {                
        applyFilters( null, null );
    }

    async function load(customerIds, customerAccountIds) {
        await loadCustomers();
        applyFilters(customerIds, customerAccountIds);
    }

    defineExpose({
        load,
        resetFilters
    })
</script>

<template>
    <div>
        <!--<div>{{selectedCustomerIds}}</div>
        <div>{{selectedCustomerAccountIds}}</div>-->

        <div v-for="customer in customers">
            <div class="columns is-gapless" style="line-height:1">
                <div class="column is-narrow">
                    <a @click="customer.expanded = !customer.expanded">
                        <i class="material-icons md-18">{{(customer.expanded == true ? "remove" : "add")}}</i>
                    </a>
                </div>
                <div class="column">
                    <label class="checkbox">
                        <input type="checkbox"
                               class="mr-1"
                               v-bind:checked="selectedCustomerIds.indexOf(customer.id) >= 0"
                               @change="customerSelectionChanged($event, customer)">{{customer.name}}
                    </label>
                    <div class="ml-3" v-for="account in customer.accounts" v-show="customer.expanded == true">
                        <label class="checkbox" :title="account.number">
                            <input type="checkbox"
                                   class="mr-1"
                                   v-bind:checked="selectedCustomerAccountIds.indexOf(account.id) >= 0"
                                   @change="accountSelectionChanged($event, account)">{{account.name}}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>